import { AuthGuard, CrudOp, externalConfiguratorAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const ExternalConfiguratorView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  return (
    <AuthGuard authScope={externalConfiguratorAuthScope} crudOp={CrudOp.READ} brand={brand}>
      <Suspense>
        <LazyExternalConfiguratorView
          brand={brand}
        />
      </Suspense>
    </AuthGuard>
  );
};

const LazyExternalConfiguratorView = lazy(importView(
  () => import("../components/ExternalConfiguratorView"),
  (it) => it.ExternalConfiguratorView,
));
